import { useQuery } from '@tanstack/react-query';
import { getRequestWithAuth } from '~/lib/api';

interface ScopeStatus {
  needs_reauth: boolean;
  missing_scopes: string[];
}

export function useScopeStatus(enabled: boolean = true) {
  return useQuery<ScopeStatus>({
    queryKey: ['scopeStatus'],
    queryFn: () => getRequestWithAuth('/api/v1/shopify/scopeStatus'),
    enabled,
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });
}
